import React from 'react';
import styled from 'styled-components';

import { QUERIES } from '../constants/mediaQueries';
import { CONTACT_URL } from '../constants/contactData';
import Button from './Button';

const ButtonContainer = styled.div`
  position: fixed;
  bottom: 9rem;
  right: 2rem;
  z-index: 98; /* Below ScrollToTopButton */
  opacity: 1;
  visibility: visible;

  ${QUERIES.maxMobile} {
    right: 1.5rem;
  }
`;

export const WhatsAppButton = () => {
  return (
    <ButtonContainer>
      <Button
        href={CONTACT_URL.whatsapp}
        iconName="FaWhatsapp"
        iconPosition="icon-only"
        iconSize="xxlarge"
        iconColour="whatsapp"
        showExternalLinkArrowIcon={false}
        colorScheme="scheme3"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact us on WhatsApp"
      />
    </ButtonContainer>
  );
};

export default WhatsAppButton;
